
export const getAddressCompany = (shopAddress = {}) => {
  const { street = '', city = '', state = '', country = '' } = shopAddress
  return [street, city, state, country].filter(str => str.trim()).join(', ')
}